import React from "react";
import { TableRow, TableCell } from "semantic-ui-react";

const recentAppointmentTableCell = props => (
  <TableRow className="row">
    <TableCell className="history_date">{props.appointmentDate}</TableCell>
    <TableCell className="history_service">
      {props.appointmentServiceName ? (
        props.appointmentServiceName
      ) : (
        <i>
          {
            window.APP.LANGUAGE.Pages.CustomerRecentAppointment
              .NoServiceSpecifiedPlaceholder
          }
        </i>
      )}
    </TableCell>
    <TableCell className="history_staff">
      {props.appointmentStaffName}
    </TableCell>
    <TableCell className="history_service">
      {props.appointmentCancelled ? (
        <div className="color-bad-things">
          {
            window.APP.LANGUAGE.Pages.CustomerRecentAppointment
              .CancelledAppointmentLabel
          }
        </div>
      ) : (
        ""
      )}
    </TableCell>
  </TableRow>
);

export default recentAppointmentTableCell;
